import React, {useState} from "react";
import VerifyLayout from "./verify";
import { Table, Button, Modal } from "react-bootstrap";
import green from "../../assets/images/profile/green.svg";
import { Link } from "react-router-dom";
import nexticon from "../../assets/images/profile/arrow.svg";
import previcon from "../../assets/images/profile/arrow.svg";

const VerifyDice = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const item1 = 10;
    return (
        <VerifyLayout>
                <div className="verify-content">

                    <h2>DICE TECHNICAL DETAILS</h2>

                    <p>This game uses two ingredients:</p>

                    <ul>
                    <li><b>Server Seed</b> - provided by us </li>
                    <li><b>Client Seed</b> - the hash for ethereum block #12818935 </li>
                    <li><b>Nonce</b> - a number that increases with each bet</li>
                    </ul>

                    <p>You will get an encrypted hash (SHA256) of the Server Seed as you begin playing. This does not change unless you change it or reveal your Server Seed.</p>

                    <p> You provide us the Client Seed which can be changed before any bet to ensure you have control over the outcome.</p>

                    <p>After each bet you make, the Nonce increments by 1.</p>

                    <p>When you verify a bet some things happen:</p>

                    <ul>
                        <li>We reveal the Server Seed of which we gave you an encrypted hash of</li>
                        <li>We re-run the three ingredients (Server Seed, Client Seed, Nonce) to re-generate the outcome of the bet for you to see</li>
                        <li>Your Nonce gets reset</li>
                        <li>Your Server Seed gets reset</li>
                    </ul>

                    <p>With this information, you can do a number of things to further verify your bet:</p>

                    <p>You can take a SHA256 of the revealed server seed and make sure that it equals what we gave you as the encrypted hash
                    Using the codesandbox provided below, you can run the exact same code we ran to determine the result of the game, using your revealed Server Seed</p>


                    <div className="verify-iframe">

                        {/* <img src={iframe} alt="" /> */}

                        <iframe src="https://dotnetfiddle.net/Widget/Z32J5a" title="Roulette"></iframe>

                    </div>

                    <Button onClick={handleShow} >DICE SEEDS</Button>

                </div>


  
                <Modal show={show} onHide={handleClose} dialogClassName="history-popup" centered>
              <Modal.Header closeButton>
                <Modal.Title>Roulette History</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <div className="history-popup-content">

              <Table striped bordered variant="dark" responsive>
              <thead>
                <tr>
                <th>Server Seed</th>
                    <th>Time</th>
                    <th>Public Seed </th>
                    <th>Result</th>
                    <th>Verify</th>
                </tr>
              </thead>
              <tbody>

              {[...Array(item1)].map((index) => (
                <tr key={index}>
                  <td>0f8eb2b3ee986a63b4b0725e78d9f9a308490f7ad07a6f271bbac244ba62f927</td>
                  <td>4:09 PM</td>
                  <td>100633302</td>
                  <td><div className="result-value"><img src={green} alt="" /> Green</div></td>
                  <td><Link to="/overview" className="verify-btn">VERIFY</Link></td>
                </tr>
                ))}
              

              </tbody>
              </Table>


              <div className="pagination">

                <Button className="disabled"><img src={previcon} alt="" /> Previous Page</Button>

                <Button>Next Page <img src={nexticon} alt="" /></Button>
                </div>

              </div>
              </Modal.Body>
            </Modal>

        </VerifyLayout>

    );
};

export default VerifyDice;

